import React, { useEffect } from "react";
import Routers from "./Routers"
import { ToastContainer } from "react-toastify";
import AuthenticateProvider from "./Contexts/AuthenticateProvider"

function App() {
  useEffect(() => {

  }, [])
  return (
    <AuthenticateProvider>
      <Routers />
      <ToastContainer theme={"light"} autoClose={2000} position="top-right" />
    </AuthenticateProvider>
  );
}

export default App;
